var actions = {
	CHANGE_COLOR: 'CHANGE_COLOR',
	PRODUCT_UPDATE: 'PRODUCT_UPDATE'
};
export default actions;